<template>
  <v-card outlined style="margin-bottom: 24px;">
    <UpdateProduct
      :state="updateLeadDialog"
      :types="types"
      :profile="profile"
      @refresh="refresh"
      @closeDialog="closeUpdate"
    />
    <div class="d-flex justify-space-between align-items-center py-6 pl-6">
      <h5 class=" text-uppercase align-self-center">Thông tin hệ đào tạo</h5>
      <v-btn
        text
        color="blue darken-4"
        class="pr-6 document-btn no-hover"
        plain
        @click="updateLead"
        style="height: 18px;"
      >
        <v-icon left>mdi-playlist-edit</v-icon>
        Cập nhập
      </v-btn>
    </div>

    <v-row class=" px-6 pb-6" no-gutters>
      <v-col cols="4">
        <p class="grey--text mb-0 mt-0">Tên viết tắt</p>
        <p class=" my-0">{{ profile.acronym }}</p>
      </v-col>
      <v-col cols="4">
        <p class="grey--text mb-0 mt-0">Khối tuyển sinh</p>
        <p class=" my-0">Khối {{ profile.grade ? profile.grade : 'Chưa có thông tin' }}</p>
      </v-col>
      <v-col cols="4">
        <p class="grey--text mb-0 mt-0">Phân loại</p>
        <p class=" my-0">{{ profile.productType ? profile.productType.name : '-' }}</p>
      </v-col>
    </v-row>
    <v-row class=" px-6 pb-6" no-gutters>
      <v-col cols="4">
        <p class="grey--text mb-0 mt-0">Trạng thái</p>
        <p class=" my-0">{{ formatLead(profile.status) }}</p>
      </v-col>
      <v-col cols="4">
        <p class="grey--text mb-0 mt-0">Ghi chú</p>
        <p class=" my-0">{{ profile.note || 'Chưa có' }}</p>
      </v-col>
      <v-col cols="4">
        <p class="grey--text mb-0 mt-0">Ngày tạo</p>
        <p class=" my-0">{{ formatTime(profile.createdAt) }}</p>
      </v-col>
    </v-row>
    <v-row class=" px-6 pb-6" no-gutters> </v-row>
  </v-card>
</template>
<script>
import UpdateProduct from '@/components/basic/form/UpdateProduct.vue'
import moment from 'moment'

export default {
  props: {
    profile: Object,
    types: Array
  },
  components: {
    UpdateProduct
  },
  data() {
    return {
      updateLeadDialog: false
    }
  },
  methods: {
    updateLead() {
      this.updateLeadDialog = true
    },
    closeUpdate() {
      this.updateLeadDialog = false
    },
    refresh() {
      this.$emit('refresh')
    },
    formatTime(time) {
      return moment(time).format('DD/MM/YYYY')
    },
    formatLead(data) {
      switch (data) {
        case 'active':
          return 'Đang hoạt động'
        case 'inactive':
          return 'Đã bị khóa'
        case 'removed':
          return 'Đã bị xóa'
        default:
          return ''
      }
    }
  }
}
</script>
